/**
 * HUB-B.1 — KPI ventes + commissions (Carlos uniquement — SEC-01).
 */
import React from 'react';
import { Lock } from 'lucide-react';

export default function ActiviteVentesKpiStrip({ totaux, commissions, isCarlosOnly }) {
  if (!isCarlosOnly) {
    return (
      <div
        className="rounded-xl border p-4 flex items-start gap-3 text-sm"
        style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
        data-testid="activite-ventes-kpi-restricted"
      >
        <Lock className="w-5 h-5 text-gray-500 shrink-0 mt-0.5" />
        <div>
          <p className="font-semibold text-[var(--rm-gray-200)]">Totaux comptables masqués</p>
          <p className="text-xs text-[var(--rm-gray-500)] mt-1">
            Ventes, acomptes, retraits et total période — réservés à l&apos;administrateur principal.
            Vous voyez la liste des opérations sans agrégats financiers.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4" data-testid="activite-ventes-kpi">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 text-sm">
        <div
          className="rounded-xl border p-3"
          style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
          data-testid="activite-kpi-ventes"
        >
          <div className="text-xs text-[var(--rm-gray-500)]">Ventes</div>
          <div className="font-bold text-[var(--rm-success)]">{(totaux?.ventes ?? 0).toFixed(2)} €</div>
        </div>
        <div
          className="rounded-xl border p-3"
          style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
          data-testid="activite-kpi-acomptes"
        >
          <div className="text-xs text-[var(--rm-gray-500)]">Acomptes</div>
          <div className="font-bold text-[var(--rm-gray-200)]">{(totaux?.acomptes ?? 0).toFixed(2)} €</div>
        </div>
        <div
          className="rounded-xl border p-3"
          style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
          data-testid="activite-kpi-retraits"
        >
          <div className="text-xs text-[var(--rm-gray-500)]">Retraits</div>
          <div className="font-bold text-[var(--rm-red-light)]">{(totaux?.retraits ?? 0).toFixed(2)} €</div>
        </div>
        <div
          className="rounded-xl border p-3"
          style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
          data-testid="activite-kpi-global"
        >
          <div className="text-xs text-[var(--rm-gray-500)]">Total période</div>
          <div className="font-bold text-[var(--rm-white)]">{(totaux?.global ?? 0).toFixed(2)} €</div>
        </div>
      </div>

      {commissions && (
        <div
          className="grid grid-cols-2 lg:grid-cols-4 gap-3 text-sm border-t pt-4"
          style={{ borderColor: 'var(--rm-border-subtle)' }}
          data-testid="activite-ventes-commissions"
        >
          <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}>
            <div className="text-xs text-[var(--rm-gray-500)]">Com. ventes (15%)</div>
            <div className="font-bold text-[var(--rm-success)]">{commissions.commission_vente.toFixed(2)} €</div>
          </div>
          <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}>
            <div className="text-xs text-[var(--rm-gray-500)]">Com. réparations (20%)</div>
            <div className="font-bold text-[var(--rm-gray-200)]">{commissions.commission_reparation.toFixed(2)} €</div>
          </div>
          <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}>
            <div className="text-xs text-[var(--rm-gray-500)]">Com. commandes (20%)</div>
            <div className="font-bold text-[var(--rm-gray-200)]">{commissions.commission_commande.toFixed(2)} €</div>
          </div>
          <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}>
            <div className="text-xs text-[var(--rm-gray-500)]">Total commissions</div>
            <div className="font-bold text-[var(--rm-white)]">{commissions.total_commission.toFixed(2)} €</div>
          </div>
        </div>
      )}

      {!commissions && (
        <p className="text-xs text-[var(--rm-gray-500)]" data-testid="activite-commissions-hint">
          Commissions : renseignez vendeur + période (dates début/fin) dans les filtres.
        </p>
      )}
    </div>
  );
}
